// function that parses course search form and result and returns GTM datalayer data object

function CourseSearchData(document, newFilterChoice) {

    var gtmData = {
        event: 'search',

        searchCounties:
            getSelectedCheckboxTexts(document, 'input[name="county"]:checked').join(', '),

        searchCourseTypes:
            getSelectedCheckboxTexts(document, `
                input[name="type"]:checked,
                input[name="vocational"]:checked,
                input[name="distancewithmeetings"]:checked,
                input[name="distancewithoutmeetings"]:checked
            `).join(', '),

        searchDisplayOnlyCoursesWithVacancies:
            String(document.querySelector('input[name="available"]')?.checked || false),

        searchCourseStarts:
            getSelectedCheckboxTexts(document, 'input[name="semester"]:checked').join(', '),

        searchStudyTempos:
            getSelectedCheckboxTexts(document, 'input[name="studypace"]:checked').join(', '),

        searchCourseDurations:
            getSelectedCheckboxTexts(document, 'input[name="courselength"]:checked').join(', '),

        searchSchools:
            getSelectedCheckboxTexts(document, 'input[name="school"]:checked').join(', '),

        searchLifeAndLivings:
            getSelectedCheckboxTexts(document, `
                input[name="internat"]:checked,
                input[name="childcare"]:checked,
                input[name="pets"]:checked
            `).join(', '),

        searchDisabilities:
            getSelectedCheckboxTexts(document, 'input[name="disability"]:checked').join(', '),

        searchStudyGrantLevels:
            getSelectedCheckboxTexts(document, 'input[name="csn"]:checked').join(', '),

        searchNumberOfCoursesInSearchResult:
            document.querySelector('#Courses')?.dataset.totalCount,

        newFilterChoice: newFilterChoice
    };

    return gtmData;
}

function getSelectedCheckboxTexts(document, selector) {
    var selectedValues = Array.from(document.querySelectorAll(selector))
        .map(function (checkbox) {
            return (checkbox.closest('.checkbox')?.innerText || checkbox.value)
                .replace(/\s+/g, ' ')
                .trim();
        })
        .filter(Boolean);

    var dataLayerMaxValLength = 100;
    var length = 0;

    if (selectedValues.length === 0) {
        selectedValues.push('Inte angiven');
    }

    return selectedValues.filter(function (val) {
        length = length + val.length + 1;
        return length <= dataLayerMaxValLength;
    });
}

export default CourseSearchData;